export enum MetricsDataAction {
  SUM = 'sum',
  AVERAGE = 'average',
  HIGH_VALUE = 'high-value',
  LOW_VALUE = 'low-value',
  GROUP_COUNT = 'group-count',
  GROUP_TOTAL = 'group-total',
}

export type MetricProps = Readonly<{
  demographicId?: string;
  additionalData: ReadonlyArray<{
    name: string;
    value: number;
  }>;
  dataAction?: MetricsDataAction;
  secondaryColumnName?: string;
  name: string;
  prefix?: string;
  suffix?: string;
  value: number;
}>;
